import { render, staticRenderFns } from "./BranchesList.vue?vue&type=template&id=d921cda6&scoped=true&"
import script from "./BranchesList.vue?vue&type=script&lang=js&"
export * from "./BranchesList.vue?vue&type=script&lang=js&"
import style0 from "./BranchesList.vue?vue&type=style&index=0&id=d921cda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d921cda6",
  null
  
)

export default component.exports